import { ImagesSquareIcon } from "@phosphor-icons/react";

type Props = {
  count: number;
};

export const HotelImageCounter = ({ count }: Props) => {
  return (
    <div className="flex items-center justify-center gap-1 rounded-full bg-gray-darken-500-d px-2.5 py-1.5 text-white backdrop-blur-[0.5px]">
      <ImagesSquareIcon size={16} />
      <span className="text-sm font-medium">{count}</span>
    </div>
  );
};
